import { useFormContext } from 'react-hook-form';
import { FilterCriteriaForm } from '@/components/table/schemas/filterCriteriaSchema.ts';
import SingleSelectInput from '@/components/form/SingleSelectInput.tsx';
import React from 'react';

export const FilterCombinator = ({ index }: { index: number }) => {
  const { control, watch } = useFormContext<FilterCriteriaForm>();
  const combinatorValue = watch('combinator');

  if (index === 0) {
    return <div className="pl-4 text-xs text-neutral-800">Gdzie</div>;
  }

  if (index === 1) {
    return (
      <SingleSelectInput
        controlSize="toolbar"
        fieldName={'combinator'}
        control={control}
        options={[
          { value: 'AND', label: 'oraz' },
          { value: 'OR', label: 'lub' },
        ]}
      />
    );
  }

  return <FilterCombinatorValuePrefix combinator={combinatorValue} />;
};

const FilterCombinatorValuePrefix = ({
  combinator,
}: {
  combinator: 'AND' | 'OR';
}) => {
  const combinatorValue = combinator === 'AND' ? 'oraz' : 'lub';
  return <div className="pl-4 text-xs text-neutral-400">{combinatorValue}</div>;
};
